import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { HttpService } from "../http.service";
import { StructureContractService } from "../interfaces/structure-contract.service";
import { ElectronService } from "../../electron.service";
import { InspectionStructureFormat } from "../../_utils/inspection-structure.utils";

@Injectable({
  providedIn: "root"
})
export class StructureOnlineService extends HttpService implements StructureContractService {
  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private router: Router,
    private electronService: ElectronService
  ) {
    super();
    super.setCookieService(cookieService);
    super.setHttpClient(http);
    super.setRouter(router);
  }

  // ST01 GET /api/v1/structure
  getStructureZip(subjectModelId?: string, inspectionId?: string, withPreset?: boolean, format?: InspectionStructureFormat): Observable<Blob> {
    const endpoint = super.getEndpoint("structure");
    let httpParams = new HttpParams();
    if (subjectModelId) {
      httpParams = httpParams.set("md", subjectModelId);
    }
    if (inspectionId) {
      httpParams = httpParams.set("ip", inspectionId);
    }
    if (withPreset !== null && withPreset !== undefined) {
      httpParams = httpParams.set("withPreset", String(withPreset));
    }
    // The server keeps the legacy layout when the format is not given
    if (format) {
      httpParams = httpParams.set("format", format);
    }

    return this.http.get(endpoint, {
      withCredentials: super.getWithCredentialsOption(),
      responseType: "blob",
      params: httpParams
    });
  }
}
